import { type FC } from 'react'
import { MICROSOFT_ADMIN_CONSENT_LINK } from '../../../common/integrations'

/**
 * Firms that manage their advisors' Microsoft tenant block the scheduling scopes until an admin
 * consents, so reconnecting alone does not fix the calendar. Shown next to an Outlook Calendar
 * that needs a reconnect, to point the advisor at the tenant-wide consent link first.
 */
export const OutlookApprovalNotice: FC = () => (
  <div className='d-flex align-items-start gap-2 zocks-p-0.75 rounded-3 zocks-bg-color-gray-100'>
    <i className='bi bi-info-circle zocks-text-gray-900 flex-shrink-0' aria-hidden='true' />
    <span className='paragraph-small zocks-text-gray-900'>
      Your IT team may need to approve the new permissions if your firm manages your Outlook account. Send them the{' '}
      <a href={MICROSOFT_ADMIN_CONSENT_LINK} target='_blank' rel='noreferrer' className='zocks-text-primary text-decoration-underline'>
        approval link
      </a>{' '}
      and reconnect once they approve. Your calendar keeps working as it does today.
    </span>
  </div>
)
